import React from "react"

import { ProjectPage, ProjectPageModel } from "pages/project-page/ProjectPage"
import { NoProductsHint } from "widgets/product-position-table/NoProductsHint"

import { FavoritesAPIStatus } from "./FavoritesAPIStatus"

export interface FavoritesPageModel extends ProjectPageModel {
  isUnavailable?: boolean
}

export const FavoritesPage = React.memo((props: FavoritesPageModel) => {
  const { isUnavailable } = props

  return isUnavailable ? (
    <FavoritesAPIStatus isUnavailable />
  ) : (
    <ProjectPage
      hideQuantity
      hideTabBar
      noDataHint={<NoProductsHint />}
      className="project-page--favorites"
      {...props}
    />
  )
})
